// extracted by mini-css-extract-plugin
export default {"invisibleButton":"CottageTrapDoor_invisibleButton__SqCj+","button5":"CottageTrapDoor_button5__RLWsq"};